module.exports = __webpack_public_path__ + "static/img/guanwang4.79661ed4.png";